// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1PivB","header_left":"Header_header_left__xQXKC","header_right":"Header_header_right__2hRqb"};